import { createSlice } from '@reduxjs/toolkit';
import { KpiDashboardState } from '../types/store.types';

const getToFromDate = (date: Date) => {
  const datee = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const fullDate = month + '/' + datee + '/' + year;
  return fullDate;
};

const getLastWeekDate = (date: Date) => {
  const lastWeekDate = new Date(date.getTime() - 6 * 24 * 60 * 60 * 1000);
  const fullDate = lastWeekDate.getMonth() + 1 + '/' + lastWeekDate.getDate() + '/' + lastWeekDate.getFullYear();
  return fullDate;
};

const initialState: KpiDashboardState = {
  branchList: [],
  announcementsData: [],
  toDate: getLastWeekDate(new Date()),
  fromDate: getToFromDate(new Date()),
  selectedBranch: '',
  selectedTypes: 'MTD',
  dropdownLoader: false,
  kpiBranch: '',
};

export const kpiBucketSlice = createSlice({
  name: 'kpiBucket',
  initialState,
  reducers: {
    addBranchList: (state, action) => {
      state.branchList = action.payload;
    },
    setAnnouncementData: (state, action) => {
      state.announcementsData = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload;
    },
    setSelectedType: (state, action) => {
      state.selectedTypes = action.payload;
    },
    setDropdownLoader: (state, action) => {
      state.dropdownLoader = action.payload;
    },
    setKpiBranch: (state, action) => {
      state.kpiBranch = action.payload;
    },
  },
});

export const kpiBucketActions = kpiBucketSlice.actions;
export default kpiBucketSlice.reducer;
